import { Component } from "react";
import styled from "styled-components";

const Button = styled.button`
  background-color: var(--color-primary);
  width: 100%;
  border-radius: 4px;
  padding: 18px 29px;
  color: black;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px  !important;
  font: inherit;
  &:hover {
    opacity: 0.8;
    background-color: var(--color-secundario);
    color: white;
  }
  border: none;
  box-shadow: 2px 2px 4px var(--color-secundario);
`;

interface ButtonLinkProps {
  isOpen: () => void;
}

class ButtonLink extends Component<ButtonLinkProps> {
  constructor(props: ButtonLinkProps) {
    super(props);
  }
  
  render() {
    const {isOpen} = this.props;
    return (
      <Button onClick={isOpen}>
        {this.props.children}
      </Button>
    );
  }
}

export default ButtonLink;